import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft.jsx';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import PropTypes from 'prop-types';
import FJRatioChoose from '../../../../common/combineComponents/FJRatioChoose/FJRatioChoose.jsx';
import FJAIVideoGeneratorData from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import { useRef } from 'react';
import FJButtonChoose from '../../../../common/combineComponents/FJButtonChoose/FJButtonChoose.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab.jsx';
import FJTextAreaWidthInspire from '../../../../common/combineComponents/FJTextAreaWidthInspire/FJTextAreaWidthInspire.jsx';
import FJImageUploadWidthHistory from '../../../../common/combineComponents/FJImageUploadWidthHistory/FJImageUploadWidthHistory.jsx';
import FJAIImageListContainer from '../../../../common/combineComponents/FJAIImageListContainer/container/FJAIImageListContainer.jsx';
import styles from './FJAIVideoGeneratorLeft.module.less';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJHelpIcon from '../../../../assets/svg/help.svg?react';
import { UPLOAD_FILE_TO_VIDEO } from '../../../../config/dataConfig/FJGenerateData.js';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJLabeledSwitch from '../../../../common/components/FJLabeledSwitch/FJLabeledSwitch.jsx';

const FJAIVideoGeneratorLeft = props => {
    const {
        currentRatio,
        changeRatio,
        onChangeQuality,
        onChangeDuration,
        currentQuality,
        currentDuration,
        tabIndex,
        onChangeTabIndex,
        uploadFile,
        originImage,
        textValue,
        onTextValueChange,
        isDraggingFile,
        setIsDraggingFile,
        uploadStatus,
        getInspire,
        showAIImageHistoryList,
        onFileDelete,
        openMediaLibrary,
        totalCredit,
        audioActive,
        onChangeAudioActive,
    } = props;
    const { onGenerate, taskStatus, freeNumCreation, isProjectLoading, creditNumber } = props;

    const isFree = freeNumCreation > 0 && creditNumber < 10;

    const ratioList = useRef(FJAIVideoGeneratorData.RATIO_LIST);
    const durationList = useRef(FJAIVideoGeneratorData.DURATION_LIST);
    const qualityList = useRef(FJAIVideoGeneratorData.QUALITY_LISL);
    const menuList = useRef(FJAIVideoGeneratorData.MENU_LIST);

    const _renderTrigger = config => {
        return (
            <div className={styles.icon} onClick={config.onClick} ref={config.ref}>
                <FJHelpIcon />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.desc} ref={config.ref}>
                {FJLocalStore._('please-choose-the-professional-mode')}
            </div>
        );
    };

    const _renderTitle = () => {
        return (
            <div className={styles.title_box}>
                <div className={styles.title}>{FJLocalStore._('mode')}</div>
                <FJDropdownNew
                    renderTrigger={_renderTrigger}
                    useAnchorBody
                    placement='rightTop'
                    trigger='click'
                    renderOverlay={_renderOverlay}
                    offsetLeft={8}
                    offsetTop={-11}
                />
            </div>
        );
    };

    return (
        <FJAppLeft>
            {!window.isEditPage && (
                <FJMenuTab list={menuList.current} curIndex={tabIndex} onChange={onChangeTabIndex} />
            )}
            <FJVerticalScroller>
                {tabIndex === 1 && (
                    <FJImageUploadWidthHistory
                        isSmallComponent
                        openMediaLibrary={openMediaLibrary}
                        originImage={originImage}
                        uploadImg={uploadFile}
                        uploadStatus={uploadStatus}
                        isDraggingFile={isDraggingFile}
                        setIsDraggingFile={setIsDraggingFile}
                        showAIImageHistoryList={showAIImageHistoryList}
                        onDelete={onFileDelete}
                        fileType={UPLOAD_FILE_TO_VIDEO}
                    />
                )}
                {/* <div className={styles.title_line}>{FJLocalStore._('prompt')}</div> */}
                <FJTextAreaWidthInspire
                    placeholder={
                        tabIndex !== 1
                            ? FJLocalStore._('describe-the-video-you-want-to-generate')
                            : FJLocalStore._('describe-the-video-you-want-to-generate-optional')
                    }
                    text={textValue}
                    onChange={onTextValueChange}
                    hasInspire={tabIndex !== 1}
                    maxLength={2000}
                    getInspire={getInspire}
                />
                <FJButtonChoose
                    title={FJLocalStore._('quality')}
                    list={qualityList.current}
                    currentValue={currentQuality}
                    onChange={onChangeQuality}
                    renderTitle={_renderTitle()}
                />
                {tabIndex === 0 && (
                    <FJRatioChoose list={ratioList.current} currentRatio={currentRatio} changeRatio={changeRatio} />
                )}
                <FJButtonChoose
                    title={FJLocalStore._('duration')}
                    list={durationList.current}
                    currentValue={currentDuration}
                    onChange={onChangeDuration}
                />
                <FJLabeledSwitch
                    title={FJLocalStore._('ai-sfx-1')}
                    onChange={onChangeAudioActive}
                    active={audioActive}
                    desc={FJLocalStore._('ai-sfx-switch-tips')}
                />
            </FJVerticalScroller>
            <FJGenerateButton
                onClick={onGenerate}
                taskStatus={taskStatus}
                freeNumCreation={freeNumCreation}
                isFree={isFree}
                useCredit={totalCredit}
                isProjectLoading={isProjectLoading}
                style={{ marginTop: '24px' }}
                isShowUsageDetail={true}
            />
            <FJAIImageListContainer />
        </FJAppLeft>
    );
};

FJAIVideoGeneratorLeft.propTypes = {
    currentRatio: PropTypes.string,
    changeRatio: PropTypes.func,
    onChangeQuality: PropTypes.func,
    onChangeDuration: PropTypes.func,
    currentQuality: PropTypes.number,
    currentDuration: PropTypes.number,
    tabIndex: PropTypes.number,
    onChangeTabIndex: PropTypes.func,
    originImage: PropTypes.object,
    textValue: PropTypes.string,
    onTextValueChange: PropTypes.func,
    uploadFile: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    uploadStatus: PropTypes.string,
    getInspire: PropTypes.func,
    showAIImageHistoryList: PropTypes.func,
    onFileDelete: PropTypes.func,
    openMediaLibrary: PropTypes.func,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    peopleImageInfo: PropTypes.object,
    clothesImageInfo: PropTypes.object,
    onUploadImage: PropTypes.func,
    selectedStyle: PropTypes.string,
    onSelectStyle: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    totalCredit: PropTypes.number,
    audioActive: PropTypes.bool,
    onChangeAudioActive: PropTypes.func,
};
export default FJAIVideoGeneratorLeft;
